// TODO: PPI-1422 - it can be removed - attachEvent was used by older browsers, then this wrapper won't be needed

/**
 * Cross-browser helper function to add event handler
 *
 * @param {HTMLElement | Document | Window} element
 * @param {string} eventType
 * @param {EventListenerOrEventListenerObject} eventHandler
 * @param {boolean} [useCapture]
 */
export function addEventListenerWrapper(element, eventType, eventHandler, useCapture) {
  if (element.addEventListener) {
    element.addEventListener(eventType, eventHandler, useCapture);

    return true;
  }

  // @ts-expect-error - browser compatibility
  if (element.attachEvent) {
    // @ts-expect-error - browser compatibility
    return element.attachEvent('on' + eventType, eventHandler);
  }

  // @ts-expect-error - browser compatibility
  element['on' + eventType] = eventHandler;
}
